/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import {Helmet} from 'react-helmet';

import {SupportedLanguage} from '../types';
import {useSeoQuery} from '../hooks/use-seo-query';

interface SeoProps {
	title: string;
	description?: string;
	lang: SupportedLanguage;
	meta?: any[];
}

function Seo({title, lang, description = '', meta = []}: SeoProps) {
	const {site} = useSeoQuery();

	const metaDescription =
		description || site.siteMetadata.siteDescription[lang];
	const dir = lang === 'ar' ? 'rtl' : 'ltr';
	const attributes = {lang, dir};

	return (
		<Helmet
			htmlAttributes={attributes}
			bodyAttributes={attributes}
			title={title}
			titleTemplate={`%s | ${site.siteMetadata.siteTitle[lang]}`}
			meta={meta}
		>
			<meta name="description" content={metaDescription} />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={metaDescription} />
			<meta property="og:type" content="website" />

			<meta property="twitter:card" content="summary" />
			<meta
				property="twitter:creator"
				content={site.siteMetadata.social.twitter}
			/>
			<meta property="twitter:title" content={title} />
			<meta property="twitter:description" content={metaDescription} />
		</Helmet>
	);
}

export default Seo;
